import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Elevation, Grid, GridCell, Button, Typography, Icon } from 'rmwc';

import { currencyFormatter, Money } from '../../components/Money';

import { runFullSimulation } from '../../actions/simulationActions';
import { Text } from '../../components/Text';
import { withRegistrationDialog } from '../../components/RegistrationDialog';
import { withEmailDialog } from '../../components/EmailDialog';

import BarChart from '../../components/charts/BarChart';

import { fetchDashboard } from '../../actions/dashboardActions';
import { fetchPeople } from '../../actions/peopleActions';
import { fetchSavingsModule } from '../../actions/savingsActions';
import SocialSecurityQuiz from './SocialSecurityQuiz';

import { fetchSocialSecurityBenefitEstimates } from '../../actions/socialSecurityActions';
import FinancialShockSidebar from './FinancialShockSidebar';
import { stdColors } from '../../components/charts/scoreConstants';

import { CTAOpt } from '../../components/Onboarding/CtaVariants';
import { wlPath, wlVar } from '../../helpers/whitelabel';

import {
  MTHeader,
  MTSkinny,
  MTWide,
  MTSubheading,
  MTSubcontent,
  MTSubcontentP,
  MTDivider,
  MTCalc,
  MTSubcontentHR,
  MTSubcontentH1,
  MTSubcontentH2,
  MTSubcontentLabel,
  MTScorePanel,
  MTCTAv3,
  MTLearnMore,
  MTLearnMoreItem,
  MTAssumptionsSection,
} from './layout';

export class SocialSecurity extends Component {
  componentWillMount() {
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    // if (!this.props.results) {
    //   this.props.runFullSimulation();
    // }
    this.fetchData();
  }

  renderChart = (key, label) => {
    const { benefits } = this.props;

    const keys = [{ name: key, fill: stdColors.harborBlue }];

    const keyData = benefits[key];
    let barData = [];

    Object.keys(keyData).map(year => {
      barData.push({ name: year, [key]: keyData[year] });
    });

    return (
      <div style={{ fontSize: '0.875rem' }}>
        <BarChart
          xLabel={label}
          responsive
          tickFormatter={tick => currencyFormatter(tick)}
          keys={keys}
          data={barData}
          noLegend
        />
      </div>
    );
  };

  fetchData = () => {
    this.props.fetchSocialSecurityBenefitEstimates();
    this.props.fetchPeople();
  };

  calcRetirementFeeSaving = () => {
    if (this.props.updatedResults && this.props.people) {
      const primaryAge = this.props.people[0].age;
      const retirementAge = 67;
      const yearsUntilRetirement = retirementAge - primaryAge;
      // person already retired
      if (yearsUntilRetirement <= 0) {
        return 0;
      }
      const savingsAmount =
        this.props.results.distribution.asset_balance.average[yearsUntilRetirement - 1] -
        this.props.updatedResults.distribution.asset_balance.average[yearsUntilRetirement - 1];
      return savingsAmount;
    }
    return 0;
  };

  render() {
    const {
      people,
      results,
      onContinue,
      openRegistrationDialog,
      openEmailDialog,
      history,
      benefits,
      lifetimeEstimates,
    } = this.props;

    if (!results || !benefits || Object.keys(benefits).length === 0) {
      return null;
    }

    return (
      <div>
        <MTHeader title="Maximize your Social Security" onClick={() => history.push(wlPath('/action-plan'))} />
        <MTSkinny>
          <MTSubheading title="Create a personalized Social Security strategy" />
          <MTSubcontent noCard>
            <MTSubcontentP>
              Social Security was created as income replacement for retirement, so no American who worked hard through
              their career would be without money to pay for basic expenses. Payouts are based on your (or your
              spouse’s) earnings and on when you take payments.
            </MTSubcontentP>
            <MTSubcontentP last>
              <strong>
                You can begin taking payouts once you reach 62 years old, but each year you wait (until 70) the amount
                of your monthly benefit will rise.
              </strong>
            </MTSubcontentP>
          </MTSubcontent>
        </MTSkinny>
        <MTDivider />
        <MTWide>
          <MTSubheading title="What’s the right claim strategy for you?" />
          <MTSubcontent noCard>
            <MTSubcontentP last>
              You'll get the most out of Social Security if you match up when you take payouts with your lifestyle and
              life expectancy. The short quiz below will give you a rough guide based on a few answers, but to get the
              right answer you should consult a financial expert.
            </MTSubcontentP>
          </MTSubcontent>
          <MTCalc
            leftWidth={6}
            rightWidth={6}
            left={
              <div style={{ height: 300 }}>
                <SocialSecurityQuiz />
              </div>
            }
            right={
              <MTAssumptionsSection title="Calculator assumptions" titleStyle="subheading2">
                <Typography tag="div" theme="text-secondary-on-background" use="body1">
                  You can get an exact estimate of your from <a href="#">ssa.gov</a>.
                </Typography>
                <div className="mt-3">{this.renderChart('primary', 'Your Claim Age')}</div>
                {benefits.partner && (
                  <div className="mt-3">{this.renderChart('primary', "Your Spouse's Claim Age")}</div>
                )}
              </MTAssumptionsSection>
            }
            disclaimer={true}
          />
        </MTWide>
        <MTSkinny>
          <Text use="caption" className="text-muted">
            These calculators are designed to be informational and educational tools only, and when used alone, do not constitute investment advice. We strongly recommend that you seek the advice of a financial services professional before making any type of investment. We also encourage you to review your investment strategy periodically as your financial circumstances change. This model is provided as a rough approximation of future financial performance. The results presented by this calculator are hypothetical and may not reflect the actual growth of any investments. {wlVar('brand_name')} is not responsible for the consequences of any decisions or actions taken in reliance upon or as a result of the information provided by these tools.
          </Text>
        </MTSkinny>
        <MTDivider />
        <MTSkinny>
          <MTCTAv3 />
        </MTSkinny>
      </div>
    );
  }
}

function getPrimaryPerson(people, dashboard) {
  if (!people.fetched || !dashboard.fetched) {
    return null;
  }
  for (const person of people.data) {
    if (person.id == dashboard.data.primary_person_id) {
      return person;
    }
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
    people: state.people.data,
    results: state.simulations.results,
    primaryPerson: getPrimaryPerson(state.people, state.modules.dashboard),
    updatedResults: state.modules.dashboard.simulation ? state.modules.dashboard.simulation.results : null,
    benefits: state.modules.socialSecurity.benefitEstimates,
  };
}

function mapDispatchToProps() {
  return {
    runFullSimulation,
    fetchDashboard,
    fetchPeople,
    fetchSavingsModule,
    fetchSocialSecurityBenefitEstimates,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(withEmailDialog(withRegistrationDialog(SocialSecurity)));
